// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_7u-0";